module.exports = "/_next/static/images/stef-2402ef6971fdf3e592cf81197b91644a.png";